import { render, staticRenderFns } from "./SectionCustomFields.vue?vue&type=template&id=06d00da4&scoped=true&"
import script from "./SectionCustomFields.vue?vue&type=script&lang=js&"
export * from "./SectionCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SectionCustomFields.vue?vue&type=style&index=0&id=06d00da4&prod&lang=sass&scoped=true&"
import style1 from "./SectionCustomFields.vue?vue&type=style&index=1&id=06d00da4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d00da4",
  null
  
)

export default component.exports